var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"news"},[_c('b-container',{staticClass:"news-container"},[_c('div',{staticClass:"list-board"},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(this.newsObj.title))]),_c('div',{staticClass:"list-text",domProps:{"innerHTML":_vm._s(_vm.markdownToHtml)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }